/* eslint-disable */
// automatically generated by the FlatBuffers compiler, do not modify

import * as flatbuffers from 'flatbuffers';

import { MobileMockPlatform } from './mobile-mock-platform';
import { RectStruct } from './rect-struct';

export class MobileMockProto {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): MobileMockProto {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsMobileMockProto(
    bb: flatbuffers.ByteBuffer,
    obj?: MobileMockProto,
  ): MobileMockProto {
    return (obj || new MobileMockProto()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsMobileMockProto(
    bb: flatbuffers.ByteBuffer,
    obj?: MobileMockProto,
  ): MobileMockProto {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new MobileMockProto()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  screenSize(obj?: RectStruct): RectStruct | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? (obj || new RectStruct()).__init(this.bb_pos + offset, this.bb!) : null;
  }

  platform(): MobileMockPlatform {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? this.bb!.readInt16(this.bb_pos + offset) : MobileMockPlatform.OSX;
  }

  appVersion(): string | null;
  appVersion(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  appVersion(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  appPackageName(): string | null;
  appPackageName(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  appPackageName(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  static startMobileMockProto(builder: flatbuffers.Builder) {
    builder.startObject(4);
  }

  static addScreenSize(builder: flatbuffers.Builder, screenSizeOffset: flatbuffers.Offset) {
    builder.addFieldStruct(0, screenSizeOffset, 0);
  }

  static addPlatform(builder: flatbuffers.Builder, platform: MobileMockPlatform) {
    builder.addFieldInt16(1, platform, MobileMockPlatform.OSX);
  }

  static addAppVersion(builder: flatbuffers.Builder, appVersionOffset: flatbuffers.Offset) {
    builder.addFieldOffset(2, appVersionOffset, 0);
  }

  static addAppPackageName(builder: flatbuffers.Builder, appPackageNameOffset: flatbuffers.Offset) {
    builder.addFieldOffset(3, appPackageNameOffset, 0);
  }

  static endMobileMockProto(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    return offset;
  }

  static createMobileMockProto(
    builder: flatbuffers.Builder,
    screenSizeOffset: flatbuffers.Offset,
    platform: MobileMockPlatform,
    appVersionOffset: flatbuffers.Offset,
    appPackageNameOffset: flatbuffers.Offset,
  ): flatbuffers.Offset {
    MobileMockProto.startMobileMockProto(builder);
    MobileMockProto.addScreenSize(builder, screenSizeOffset);
    MobileMockProto.addPlatform(builder, platform);
    MobileMockProto.addAppVersion(builder, appVersionOffset);
    MobileMockProto.addAppPackageName(builder, appPackageNameOffset);
    return MobileMockProto.endMobileMockProto(builder);
  }
}
